module.exports = __webpack_public_path__ + "img/hover-facebook.9e8544ce.svg";